module.exports = __webpack_public_path__ + "img/electronic_electric_use.7b75fff3.svg";